import NotificationCentreStore from '../stores/NotificationCentreStore';
import ModalActions from '../actions/ModalActions';

import NotificationCentreModal from '../components/notificationCentre/Modal';


export const displayNotifications = () => {
    const notifications = NotificationCentreStore.getNotifications();
    if (notifications.size === 1) {
        notifications.first().onClick();
    } else if (notifications.size > 1) {
        ModalActions.open(NotificationCentreModal, { notifications });
    }
};



// WEBPACK FOOTER //
// ./src/helpers/NotificationCentre.js